(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[159],{

/***/ 8097:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/chooseProgram",
      function () {
        return __webpack_require__(1781);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4530:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var country_calling_code__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8187);
/* harmony import */ var _Contact_module_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5792);
/* harmony import */ var _Contact_module_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Contact_module_css__WEBPACK_IMPORTED_MODULE_3__);




var ContactInput = function(param) {
    var value = param.value, _placeholder = param.placeholder, placeholder = _placeholder === void 0 ? "Select Country" : _placeholder, onChange = param.onChange, _required = param.required, required = _required === void 0 ? false : _required;
    var dropdownRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var flagRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), show = ref[0], setShow = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        country: "India",
        countryCodes: [
            "91"
        ],
        isoCode2: "IN",
        isoCode3: "IND"
    }), selected = ref1[0], setSelected = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(country_calling_code__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP), countries = ref2[0], setCountries = ref2[1];
    var countryChangeHandler = function(e) {
        setCountries(country_calling_code__WEBPACK_IMPORTED_MODULE_2__/* ["default"].filter */ .ZP.filter(function(m) {
            return m.country.toLowerCase().includes(e.target.value.toLowerCase()) || m.countryCodes[0].toString().includes(e.target.value.toLowerCase());
        }));
    };
    var countrySelectHandler = function(c) {
        setSelected(c);
        setShow(false);
    };
    var countryClickHandler = function() {
        setShow(true);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (show) {
            document.addEventListener("click", function(e) {
                if (!dropdownRef.current.contains(e.target) && !flagRef.current.contains(e.target)) {
                    setShow(false);
                }
            });
        }
    });
    var changeHandler = function(e) {
        onChange({
            code: selected.countryCodes[0],
            number: e.target.value,
            country: selected.isoCode2
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "".concat((_Contact_module_css__WEBPACK_IMPORTED_MODULE_3___default().contactComponent), " contactInput mt-4 mb-4"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_Contact_module_css__WEBPACK_IMPORTED_MODULE_3___default().container),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        ref: flagRef,
                        className: "ms-0",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                onClick: countryClickHandler,
                                children: selected && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    alt: selected.country,
                                    src: "http://purecatamphetamine.github.io/country-flag-icons/3x2/".concat(selected.isoCode2.toUpperCase(), ".svg"),
                                    width: "23px"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                className: "coucode",
                                onClick: countryClickHandler,
                                children: [
                                    "+",
                                    selected.countryCodes[0] || "91 "
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                        type: "number",
                        onInput: function(e) {
                            return e.target.value = e.target.value.slice(0, 10);
                        },
                        value: value,
                        onChange: changeHandler,
                        className: (_Contact_module_css__WEBPACK_IMPORTED_MODULE_3___default().contactInput2),
                        required: required
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                ref: dropdownRef,
                className: "".concat((_Contact_module_css__WEBPACK_IMPORTED_MODULE_3___default().dropdown), " ").concat(show && (_Contact_module_css__WEBPACK_IMPORTED_MODULE_3___default().show)),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                        onChange: countryChangeHandler,
                        placeholder: "Search"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_Contact_module_css__WEBPACK_IMPORTED_MODULE_3___default().dropdownContent),
                        children: countries.map(function(c) {
                            if (c.country === "Netherlands Antilles") return;
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                onClick: function() {
                                    return countrySelectHandler(c);
                                },
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        alt: c.country,
                                        src: "http://purecatamphetamine.github.io/country-flag-icons/3x2/".concat(c.isoCode2, ".svg"),
                                        width: "24px"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                        className: "gray",
                                        style: {
                                            marginRight: "4px"
                                        },
                                        children: [
                                            "+ ",
                                            c.countryCodes[0]
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        children: c.country
                                    })
                                ]
                            }, c.isoCode3);
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ContactInput);


/***/ }),

/***/ 1665:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1799);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);




var Input = function(_param) {
    var _decimalPlaces = _param.decimalPlaces, decimalPlaces = _decimalPlaces === void 0 ? 2 : _decimalPlaces, onChange = _param.onChange, _max = _param.max, max = _max === void 0 ? 650 : _max, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "decimalPlaces",
        "onChange",
        "max"
    ]);
    var changeHandler = function(e) {
        var regex = /^([0-9]*|[0-9]*\.[0-9]{0,2})$/;
        if (regex.test(e.target.value)) {
            onChange(e);
        }
    };
    var keydownHandler = function(e) {
        if (e.keyCode === 69) {
            e.preventDefault();
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, rest), {
        type: "number",
        max: max,
        onChange: changeHandler,
        onKeyDown: keydownHandler
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Input);


/***/ }),

/***/ 1781:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ chooseProgram; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(1799);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./components/programs/Form1.jsx

var Form1 = function(param) {
    var formState = param.formState, nextHandler = param.nextHandler, changeHandler = param.changeHandler;
    var gender = formState === null || formState === void 0 ? void 0 : formState.gender;
    var clickHandler = function(gender) {
        changeHandler({
            gender: gender
        });
        nextHandler();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "programsContainer programsContainer1",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "fo-26 bco text-center fw-700 mfo-22",
                children: "Select your gender"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "row m-0 mt-4 genderSelection",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        name: "gender",
                        className: "col-6 col-sm-6 m-auto text-center",
                        onClick: function() {
                            return clickHandler("Male");
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "bmr_image m-auto ".concat(gender === "Male" ? "active" : ""),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: gender === "Male" ? "/assets/men purple.png" : "/assets/men.png",
                                    className: "w-100 m-auto",
                                    alt: "Gender Male"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-center mt-3 blogCategoryTitle fw-600",
                                children: "Male"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        name: "female",
                        className: "col-6 col-sm-6 m-auto text-center",
                        onClick: function() {
                            return clickHandler("Female");
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "bmr_image m-auto ".concat(gender === "Female" ? "active" : ""),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: gender === "Female" ? "/assets/women purple.png" : "/assets/women.png",
                                    className: "w-100 m-auto",
                                    alt: "Gender Female"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-center mt-3 blogCategoryTitle fw-600",
                                children: "Female"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var programs_Form1 = (Form1);

;// CONCATENATED MODULE: ./components/programs/Form2.jsx

var Form2 = function(param) {
    var state = param.state, changeHandler = param.changeHandler, nextHandler = param.nextHandler;
    var data = [
        {
            value: "20s",
            image: "/assets/age1.png",
            image2: "/assets/agem1.png"
        },
        {
            value: "30s",
            image: "/assets/age2.png",
            image2: "/assets/agem2.png"
        },
        {
            value: "40s",
            image: "/assets/age3.png",
            image2: "/assets/agem3.png"
        },
        {
            value: "50s",
            image: "/assets/age4.png",
            image2: "/assets/agem4.png"
        }
    ];
    var clickHandler = function(value) {
        changeHandler({
            age_group: value
        });
        nextHandler();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "programsContainer programsContainer2",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "fo-26 bco text-center fw-700 mfo-22",
                children: "What's your age group?"
            }),
            state.gender == "Female" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "row m-0 mt-4 genderSelection",
                children: data.map(function(elem, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card, {
                        value: elem.value,
                        image: elem.image,
                        clickHandler: clickHandler
                    }, index);
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "row m-0 mt-4 genderSelection",
                children: data.map(function(elem, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card, {
                        value: elem.value,
                        image: elem.image2,
                        clickHandler: clickHandler
                    }, index);
                })
            })
        ]
    });
};
/* harmony default export */ var programs_Form2 = (Form2);
var Card = function(param) {
    var image = param.image, value = param.value, clickHandler = param.clickHandler;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "col-6 col-sm-6 ms-auto me-auto mb-4 text-center",
        onClick: function() {
            return clickHandler(value);
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bmr_image m-auto",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: image,
                    className: "w-100 m-auto",
                    alt: "age1"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-center mt-3 blogCategoryTitle fw-600",
                children: value
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/Input.jsx
var Input = __webpack_require__(1665);
;// CONCATENATED MODULE: ./components/programs/Form3.jsx





var Form3 = function(param) {
    var nextHandler = param.nextHandler, changeHandler = param.changeHandler, _formState = param.formState, formState = _formState === void 0 ? {} : _formState, _loading = param.loading, loading = _loading === void 0 ? false : _loading;
    var heightFoot = (0,react.useRef)(null);
    var heightInches = (0,react.useRef)(null);
    var ref = (0,react.useState)(0), foot = ref[0], setFoot = ref[1];
    var ref1 = (0,react.useState)(0), inches = ref1[0], setInches = ref1[1];
    var ref2 = (0,react.useState)(formState.weight ? formState.weight : ""), weight = ref2[0], setWeight = ref2[1];
    var ref3 = (0,react.useState)("ft"), heightMetric = ref3[0], setHeightMetric = ref3[1];
    var setHeight = function(value) {
        changeHandler({
            height: value
        });
    };
    var weightChangeHandler = function(e) {
        setWeight(e.target.value);
        changeHandler({
            weight: parseFloat(e.target.value)
        });
    };
    var heightHandler = function(e) {
        switch(e.target.name){
            case "foot":
                return setFoot(e.target.value);
            case "inches":
                return setInches(e.target.value);
        }
        if (heightMetric === "ft") {
            setHeight(inches * 2.54 + foot * 30.48);
        } else if (heightMetric === "cm") {
            setHeight(foot);
        } else {
            setHeight(foot * 100);
        }
    };
    var submitHandler = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(e) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        e.preventDefault();
                        if (foot != "" && weight != "") {
                            nextHandler();
                        }
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function submitHandler(e) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "programsContainer programsContainer3",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
            onSubmit: submitHandler,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "row m-0 mt-5",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-3 col-sm-3 m-auto",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "blogCategoryTitle fw-600",
                                children: "Height"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-9 col-sm-9 p-0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "row m-0",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-6 col-sm-6 ps-0",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            className: "calculatorInput w-100",
                                            value: foot,
                                            name: "foot",
                                            type: "number",
                                            onChange: heightHandler,
                                            max: 7,
                                            required: true
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-6 col-sm-6",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "row m-0 d-flex",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                                className: "calculatorInput w-100",
                                                onChange: function(e) {
                                                    return setHeightMetric(e.target.value);
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                        value: "ft",
                                                        children: "Feet"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                        value: "cm",
                                                        children: "cm"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                        value: "m",
                                                        children: "m"
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "row m-0 mt-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-3 col-sm-3 m-auto",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "blogCategoryTitle fw-600"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-9 col-sm-9 p-0",
                            children: heightMetric === "ft" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "row m-0",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-6 col-sm-6 ps-0",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                            className: "calculatorInput w-100",
                                            value: inches,
                                            name: "inches",
                                            onChange: heightHandler,
                                            max: 150
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-6 col-sm-6",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "row m-0 d-flex",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "calculatorInput w-100 purp calculatorInput_3",
                                                children: "Inches"
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "row m-0 mt-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-3 col-sm-3 m-auto",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "blogCategoryTitle fw-600",
                                children: "Weight"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-9 col-sm-9 p-0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "row m-0",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-6 col-sm-6 ps-0",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                            className: "calculatorInput w-100",
                                            value: weight,
                                            onChange: weightChangeHandler,
                                            required: true
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-6 col-sm-6",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                            className: "calculatorInput2 purp",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                    value: "kg",
                                                    children: "Kg"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                    value: "lbs",
                                                    children: "Lbs"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-center mt-3",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "submit",
                        className: "btn sendButton mb-0",
                        children: "Submit"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var programs_Form3 = (Form3);

;// CONCATENATED MODULE: ./components/programs/Form4.jsx

var Form4 = function(param) {
    var state = param.state, changeHandler = param.changeHandler, loading = param.loading, nextHandler = param.nextHandler, prevHandler = param.prevHandler;
    var clickHandler = function(title) {
        changeHandler({
            activity: title
        });
        nextHandler();
    };
    var data = [
        {
            title: "Not Very Active",
            desc: "Spend most of the day sitting (e.g., bankteller, desk job). "
        },
        {
            title: "Lightly Active",
            desc: "Spend a good part of the day on your feet(e.g., teacher, salesperson). "
        },
        {
            title: "Active",
            desc: "Spend a good part of the day doing some physical activity (e.g., food server, postal carrier). "
        },
        {
            title: "Very Active",
            desc: "Spend a good part of the day doing heavy physical activity (e.g., bike messenger, carpenter). "
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "programsContainer programsContainer4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "fo-26 bco text-center fw-700 mfo-22",
                children: "What's your Activity level?"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "row m-0 mt-4 activitySelection",
                children: data.map(function(elem) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Form4_Card, {
                        data: elem,
                        clickHandler: clickHandler
                    }, elem.title);
                })
            })
        ]
    });
};
/* harmony default export */ var programs_Form4 = (Form4);
var Form4_Card = function(param) {
    var data = param.data, clickHandler = param.clickHandler;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "col-6 col-sm-6 m-auto text-center mb-4",
        onClick: function() {
            return clickHandler(data.title);
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "activityDiv",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-white fo-20 fw-600 cmfo-16",
                    children: data.title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-white fo-14 cmfo-12",
                    children: data.desc
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/programs/Form5.jsx

var Form5 = function(param) {
    var state = param.state, changeHandler = param.changeHandler, loading = param.loading, nextHandler = param.nextHandler, prevHandler = param.prevHandler;
    var data = [
        "I wish to lose more than 10 kgs",
        " I wish to tone my body and lose 5 to 10 kgs.",
        "I wish to lose post-pregnancy weight",
        "I have medical issues and wish to change my diet and lifestyle",
        "I wish to gain weight as Im skinny"
    ];
    var clickHandler = function(text) {
        changeHandler({
            goal: text
        });
        nextHandler();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "programsContainer programsContainer5",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "fo-26 bco text-center fw-700 mfo-22",
                children: "What's your Goal ?"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "row m-0 mt-4 activitySelection",
                children: data.map(function(elem, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Form5_Card, {
                        text: elem,
                        full: index === data.length - 1,
                        clickHandler: clickHandler
                    }, elem);
                })
            })
        ]
    });
};
/* harmony default export */ var programs_Form5 = (Form5);
var Form5_Card = function(param) {
    var full = param.full, text = param.text, clickHandler = param.clickHandler;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: full ? "col-12 col-sm-12 ms-auto me-auto mt-4 text-center" : "col-6 col-sm-6 mt-4 text-center",
        onClick: function() {
            return clickHandler(text);
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "goalsDiv",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-white fo-16 fw-600 cmfo-12",
                children: text
            })
        })
    });
};

// EXTERNAL MODULE: ./components/ContactInput.jsx
var ContactInput = __webpack_require__(4530);
;// CONCATENATED MODULE: ./components/programs/Form6.jsx



var Form6 = function(param) {
    var submitHandler = param.submitHandler, changeHandler = param.changeHandler, _loading = param.loading, loading = _loading === void 0 ? false : _loading;
    var progName = (0,react.useRef)(null);
    var progEmail = (0,react.useRef)(null);
    var ref = (0,react.useState)(null), phone = ref[0], setPhone = ref[1];
    var sendHandler = function(e) {
        e.preventDefault();
        submitHandler();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "programsContainer programsContainer6",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "fo-26 txtco text-center fw-600 mfo-22 cmfo-18",
                children: "You’re almost done!"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "fo-22 txtco text-center mfo-13 mt-4 cmfo-14",
                children: [
                    "After submitting this form, our consultant shall ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "reach out to you within 48 hours to guide you."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                className: "text-center",
                onSubmit: sendHandler,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        name: "name",
                        className: "contactInput mt-4",
                        placeholder: "Name",
                        onChange: function(e) {
                            return changeHandler({
                                name: e.target.value
                            });
                        },
                        required: true,
                        ref: progName
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "prog_contact",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactInput/* default */.Z, {
                            value: phone && phone.number,
                            onChange: function(value) {
                                return changeHandler({
                                    phone: value.code + value.number
                                });
                            },
                            required: true
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "email",
                        ref: progEmail,
                        name: "email",
                        className: "contactInput",
                        placeholder: "Email",
                        onChange: function(e) {
                            return changeHandler({
                                email: e.target.value
                            });
                        },
                        required: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                        name: "message",
                        className: "contactTextarea mt-4",
                        placeholder: "Your Message (Optional)",
                        onChange: function(e) {
                            return changeHandler({
                                message: e.target.value
                            });
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "submit",
                        className: "btn sendButton pulsating",
                        disabled: loading,
                        children: "Submit"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var programs_Form6 = (Form6);

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/programs/Success.jsx


var Success = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: {
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            style: {
                display: "flex",
                flexDirection: "column",
                alignItems: "center"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: "assets/success.svg",
                    alt: "success",
                    style: {
                        height: "100px",
                        margin: "20px auto"
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "fo-34 lh-34 mt-2 mb-3 fw-700 text-center mfo-24",
                    children: [
                        "Consultation Booked ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        "Successfully"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "text-center txtco fo-20 fw-600 mfo-16",
                    children: [
                        "Our consultant shall reach out to you ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        "within 48 hours to guide you!"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                    className: "successhr"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/programs",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "btn sendButton consultationButton successbtn",
                        children: "Check out our programmes"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var programs_Success = (Success);

// EXTERNAL MODULE: ./node_modules/@splidejs/react-splide/dist/js/react-splide.esm.js
var react_splide_esm = __webpack_require__(7677);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./utils/urls.js
var urls = __webpack_require__(1510);
;// CONCATENATED MODULE: ./pages/chooseProgram.jsx
















var ChooseProgram = function() {
    var splide = (0,react.useRef)(null);
    var ref = (0,react.useState)({}), formState = ref[0], setFormState = ref[1];
    var ref1 = (0,react.useState)(0), formStep = ref1[0], setFormStep = ref1[1];
    var ref2 = (0,react.useState)(false), loading = ref2[0], setLoading = ref2[1];
    var successStep = 6;
    var failureStep = 7;
    var prevStep = function() {
        splide.current.splide.go(formStep - 1);
        setFormStep(formStep - 1);
    };
    var nextStep = function() {
        splide.current.splide.go(formStep + 1);
        setFormStep(formStep + 1);
    };
    var jumpToStep = function(step) {
        splide.current.splide.go(step);
        if (step > formStep + 1) {
            return;
        } else {
            setFormStep(step);
        }
    };
    var submitHandler = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var url;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        url = urls/* baseUrl */.F + "/api/v1/program_reaches/";
                        setLoading(true);
                        _ctx.next = 5;
                        return axios_default().post(url, formState);
                    case 5:
                        setFormState({});
                        setLoading(false);
                        jumpToStep(successStep);
                        _ctx.next = 14;
                        break;
                    case 10:
                        _ctx.prev = 10;
                        _ctx.t0 = _ctx["catch"](0);
                        setLoading(false);
                        jumpToStep(failureStep);
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    10
                ]
            ]);
        }));
        return function submitHandler() {
            return _ref.apply(this, arguments);
        };
    }();
    var changeHandler = function(data) {
        setFormState((0,_object_spread/* default */.Z)({}, formState, data));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "transformationStories",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: "https://assets.alanvidyushbaptist.com/optimumwellness_logo.jpg"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "Choose Program || Optimum Wellness"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: "fo-34 fw-700 text-center mt-md-5 mb-md-5 mfo-22 p-3 p-md-0",
                children: "Find out which program is right for you"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StepTracker, {
                step: formStep,
                jumpToStep: jumpToStep
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_splide_esm/* Splide */.tv, {
                ref: splide,
                options: {
                    arrows: false,
                    drag: false,
                    pagination: false
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_splide_esm/* SplideSlide */.jw, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(programs_Form1, {
                            state: formState,
                            changeHandler: changeHandler,
                            nextHandler: nextStep,
                            prevHandler: prevStep
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_splide_esm/* SplideSlide */.jw, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(programs_Form2, {
                            state: formState,
                            changeHandler: changeHandler,
                            nextHandler: nextStep,
                            prevHandler: prevStep
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_splide_esm/* SplideSlide */.jw, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(programs_Form3, {
                            state: formState,
                            changeHandler: changeHandler,
                            nextHandler: nextStep,
                            prevHandler: prevStep
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_splide_esm/* SplideSlide */.jw, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(programs_Form4, {
                            state: formState,
                            changeHandler: changeHandler,
                            nextHandler: nextStep,
                            prevHandler: prevStep
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_splide_esm/* SplideSlide */.jw, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(programs_Form5, {
                            state: formState,
                            changeHandler: changeHandler,
                            nextHandler: nextStep,
                            prevHandler: prevStep
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_splide_esm/* SplideSlide */.jw, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(programs_Form6, {
                            state: formState,
                            changeHandler: changeHandler,
                            submitHandler: submitHandler,
                            prevHandler: prevStep,
                            loading: loading
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_splide_esm/* SplideSlide */.jw, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(programs_Success, {})
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var chooseProgram = (ChooseProgram);
var StepTracker = function(param) {
    var jumpToStep = param.jumpToStep, step = param.step;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "workflowToggleSection mt-4 programFlowSection",
        children: [
            1,
            2,
            3,
            4,
            5,
            6
        ].map(function(i) {
            var clickHandler = function() {
                if (i - 1 <= step) {
                    jumpToStep(i - 1);
                }
            };
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                onClick: clickHandler,
                children: [
                    i != 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "workflowToggleDiv cursorPointer ".concat(i - 1 <= step || i == 1 ? "active" : "false"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "fo-20 fw-700 mfo-14",
                            children: i
                        })
                    })
                ]
            }, i);
        })
    });
};


/***/ }),

/***/ 1510:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ baseUrl; }
/* harmony export */ });
var baseUrl = "https://itchy-blue-seagull.cyclic.app";
// export const domainUrl = "https://optimumwellness.in";
// export const baseUrl = `http://localhost:8081`;
// http://localhost:8081
var urlSet = {
    // Blogs
    get_blogApi: {
        // Get blogs
        url: baseUrl + "/api/v1/blogs",
        method: "GET"
    },
    post_blogApi: {
        // Add a new blog
        url: baseUrl + "/api/v1/blogs/",
        method: "POST"
    },
    edit_blogApi: {
        // Edit blog
        url: baseUrl + "/api/v1/blogs/",
        method: "PATCH"
    },
    delete_blogApi: {
        // Delete a blog
        url: baseUrl + "/api/v1/blogs/",
        method: "DELETE"
    },
    get_AuthorblogApi: {
        // Get blogs of an author
        url: baseUrl + "/api/v1/blogs/author/",
        method: "GET"
    },
    get_featuredblogApi: {
        // Get featured blogs
        url: baseUrl + "/api/v1/blogs/featured",
        method: "GET"
    },
    data_intervalApi: {
        // set data interval
        url: baseUrl + "/api/v1/blogs/updateDataInterval",
        method: "PATCH"
    },
    // Admin
    adminLoginApi: {
        // Admin login
        url: baseUrl + "/api/v1/auth/api/v1/auth/login",
        method: "POST"
    },
    adminUpdateApi: {
        // Admin login
        url: baseUrl + "/api/v1/auth/api/v1/auth/update",
        method: "PATCH"
    },
    // Admin blogs
    add_blog_to_featuredApi: {
        // Add to featured blogs
        url: baseUrl + "/api/v1/admin/featuredBlog/",
        method: "PATCH"
    },
    delete_blog_from_featuredApi: {
        // Delete from featured blogs
        url: baseUrl + "/api/v1/admin/featuredBlog/",
        method: "DELETE"
    },
    // Admin services
    viewServicesApi: {
        // To get services
        url: baseUrl + "/api/v1/admin/service/",
        method: "GET"
    },
    getMainServiceApi: {
        // To get services based on level
        url: baseUrl + "/api/v1/admin/service",
        method: "GET"
    },
    addServiceApi: {
        // To add new service
        url: baseUrl + "/api/v1/admin/service",
        method: "POST"
    },
    deleteServiceApi: {
        // To delete services
        url: baseUrl + "/api/v1/admin/service/",
        method: "DELETE"
    },
    editServicesApi: {
        // Update service names
        url: baseUrl + "/api/v1/admin/service/",
        method: "PATCH"
    },
    // Admin offers
    editOffersApi: {
        // Update offer
        url: baseUrl + "/api/v1/admin/offer/",
        method: "PATCH"
    },
    deleteOffersApi: {
        // Delete offer
        url: baseUrl + "/api/v1/admin/offer/",
        method: "DELETE"
    },
    // Admin coupons
    viewCouponsApi: {
        // Get all coupons
        url: baseUrl + "/api/v1/admin/coupon",
        method: "GET"
    },
    addCouponsApi: {
        // Add new coupon
        url: baseUrl + "/api/v1/admin/coupon/",
        method: "POST"
    },
    deleteCouponsApi: {
        // Delete a coupon
        url: baseUrl + "/api/v1/admin/coupon/",
        method: "DELETE"
    },
    // Payments
    applyCouponApi: {
        // Apply coupon
        url: baseUrl + "/api/v1/payment/applyCoupon",
        method: "POST"
    },
    paymentApi: {
        // Create payment order id
        url: baseUrl + "/api/v1/payment/generateReceipt",
        method: "POST"
    },
    verifyPaymentApi: {
        // Verify payments status after razorpay
        url: baseUrl + "/api/v1/payment/verifyPayment",
        method: "POST"
    },
    // Admin transactions
    viewTransactionsApi: {
        // View all transactions
        url: baseUrl + "/api/v1/transaction",
        method: "GET"
    },
    addTransactionsApi: {
        // Add transactions
        url: baseUrl + "/api/v1/transaction/",
        method: "POST"
    },
    updateTransactionsApi: {
        // Update transactions
        url: baseUrl + "/api/v1/transaction/",
        method: "PATCH"
    },
    deleteTransactionsApi: {
        // Delete transactions
        url: baseUrl + "/api/v1/transaction/",
        method: "DELETE"
    },
    // Add employees
    viewEmployeesApi: {
        // Get all employees
        url: baseUrl + "/api/v1/employees/?index=0&limit=50",
        method: "GET"
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (urlSet);


/***/ }),

/***/ 5792:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"contactComponent":"Contact_contactComponent___mbT2","container":"Contact_container__TvrFr","contactInput2":"Contact_contactInput2__271RP","dropdown":"Contact_dropdown__SpecU","dropdownContent":"Contact_dropdownContent___VBtL","show":"Contact_show__GgsaE"};

/***/ }),

/***/ 9534:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties_loose.mjs
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs


function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [217,782,187,774,888,179], function() { return __webpack_exec__(8097); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);